<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :pager-count="pagerCount"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'paginationComponents',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      }
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 5
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      if (this.currentPage * val > this.total) {
        this.currentPage = 1
      }
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: none;
  text-align: right;
  padding: 1.125rem 1rem 1.56rem;
  color: #fff;
  font-size: 14px;
  .el-pagination__sizes{
    color: #fff;
  }
 
}
.pagination-container.hidden {
  display: none;

}
</style>
<style>
.pagination-container .el-pagination__total{
  float: left;
  color: #06B0FF;
  font-size: 0.875rem;
}
.pagination-container .el-input__inner{
  background: none;
  color: #fff;
}
.pagination-container .el-select .el-input .el-select__caret{
  color: #fff;
  display: none;
}
.pagination-container .el-pagination.is-background .btn-next,
.pagination-container .el-pagination.is-background .btn-prev,
.pagination-container .el-pagination.is-background .el-pager li{
  background: rgba(38, 70, 111, 0.4);
  list-style-type: none;
  color: #D7E7FE;
  text-align: center;
}
.pagination-container .el-pagination.is-background .el-pager li:not(.disabled).active{
  color: #06B0FF;
  background: rgba(38, 70, 111, 0.4);
}
.pagination-container i{
  display: inline-block;
  width: 12px !important;
  height: 12px !important;
  background: none !important;
  position: relative !important;
}
.pagination-container .el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
  display: inline-block;
  margin-top: 5px;
}
.pagination-container .el-pagination__jump{
  color: #B1B4B7;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  margin: 0 5px;
  min-width: 30px;
}
.el-pager li{
  padding: 0 4px;
  height: 28px;
  line-height: 28px;
  font-size: 13px;
}
.el-pager .more::before{
  line-height: 30px;
}
.el-pager, .el-pager li{
  vertical-align: middle;
}
.el-pagination button, .el-pagination span:not([class*=suffix]){
  font-size: 13px;
  line-height: 28px;
  vertical-align: middle;
}
.el-pager li.btn-quicknext, .el-pager li.btn-quickprev{
  line-height: 28px;
}
.pagination-container .el-pagination.is-background .btn-next, .pagination-container .el-pagination.is-background .btn-prev, .pagination-container .el-pagination.is-background .el-pager li{
  height: 28px;
  line-height: 28px;
}
</style>
